import React, { Component } from 'react'
import { func, shape } from 'prop-types'
import { translate } from 'react-i18next'
import { initialization, stores, view } from '../../stores'
import { SubHero } from '../../components/header/SubHero'
import { NoGardeners } from '../../components/ui/states/NoGardeners'
import { Loader } from '../../components/ui/states/Loader'
import { Step, Stepper } from '../../components/ui/states/Stepper'
import { NeedsStepV1 } from '../../components/inquiry/v1/NeedsStepV1'
import { GardenersStep } from '../../components/inquiry/GardenersStep'
import { DisponibilitiesStepV1 } from '../../components/inquiry/v1/DisponibilitiesStepV1'
import { InformationsStep } from '../../components/inquiry/InformationsStep'
import { useParams } from '../../utilities/url'
import { PagesPaths } from '../../constants/Pages'
import { LeadFunnels } from '../../constants/LeadFunnels'
import { scrollToTop, addNoIndexIfNotExists, removeNoIndexIfExists } from '../../utilities/window'
import { InquiryPathVersions } from '../../stores/inquiry'
import { NeedsStepV2 } from '../../components/inquiry/v2/NeedsStepV2'
import { InquiryTypeV2 } from '../../components/inquiry/v2/InquiryTypeV2'
import { DisponibilitiesStepV2 } from '../../components/inquiry/v2/DisponibilitiesStepV2'
import { AddressStepV2 } from '../../components/inquiry/v2/AddressStepV2'

class InquiryCreationPageComponent extends Component {
  hasInitializationParams (params) {
    return params.search || (params.postalCode && params.city)
  }

async componentDidMount () {
  // Conversion tunnel — not meant to be indexed by search engines
  addNoIndexIfNotExists()

  const { location, history } = this.props
  const params = useParams(location.search)

  // Capture pro business referral code (apport d'affaire L2) - independent from sponsor system
  if (params.pro_apport) {
    stores.search.setProBusinessReferral(params.pro_apport)
  }

  if (this.hasInitializationParams(params)) {
    // Case: access with URL parameters
    stores.inquiry.clear()
    await initialization

    var urlCode = params.search || params.postalCode

    // Entry from the WordPress postal code search — captured before the URL is rewritten below.
    // A refresh on the rewritten URL (same code) keeps the funnel already captured (e.g. SITE_CARTE from /jardiniers)
    if (!stores.search.search.entryFunnel || urlCode !== stores.search.search.postalCode) {
      stores.search.setEntryFunnel(LeadFunnels.SITE_CODE_POSTAL)
    }

    // Reset stale cache if URL param doesn't match stored postal code
    if (urlCode && stores.search.search.postalCode !== urlCode) {
      stores.search.gardeners = []
      stores.search.search.postalCode = null
      stores.search.search.city = null
      stores.search.search.allPostalCodesOfCity = null
    }

    let customerId = null
    if (stores.authentication.isAuthententicated()) {
      stores.inquiry.setAccount({ account: stores.account.connected })
      customerId = stores.account.connected.id
    }

    if (params.search) {
      await stores.search.setQuery({ code1: params.search, customerId })
    } else {
      await stores.search.setSearch({ ...params, customerId })
      stores.inquiry.setAddress(params)
    }

    stores.search.deselectAll()

    // Keep postal code in URL so refresh/share works and stale cache can't corrupt state
    var resolvedCode = stores.search.search.postalCode
    if (resolvedCode) {
      history.replace(PagesPaths.INQUIRY.path + '?search=' + resolvedCode)
    } else {
      history.replace(PagesPaths.INQUIRY.path)
    }
  } else {
    // Case: normal browsing (uses cache) — e.g. coming from /jardiniers listing
    // or from the WordPress "Trouver mon jardinier" link (no funnel captured yet)
    if (!stores.search.search.entryFunnel) {
      stores.search.setEntryFunnel(LeadFunnels.SITE_CODE_POSTAL)
    }
    await stores.search.setSearch()
    // If we have a postal code in cache, reflect it in URL for consistency
    var cachedCode = stores.search.search.postalCode
    if (cachedCode) {
      history.replace(PagesPaths.INQUIRY.path + '?search=' + cachedCode)
    }
  }

  // Simple synchronization
  stores.inquiry.code = stores.search.search.sponsor || stores.search.search.postalCode
  stores.inquiry.selected = stores.search.selected
}

  componentWillUnmount () {
    removeNoIndexIfExists()
  }

  get breadcrumbs () {
    const path = (stores.search.search.postalCode
      ? [stores.search.search.postalCode, stores.search.search.city]
      : [stores.search.search.postalCode]).filter(x => x).join(' ')
    return [
      { name: `${this.props.t('common:visits:my_visit')}${path ? ', ' + path : ''}` }
    ]
  }

  previous () {
    if (stores.inquiry.step > 0) {
      stores.inquiry.step -= 1
      scrollToTop()
    }
  }

  next () {
    if (
      (stores.inquiry.step < 3 && stores.inquiry.pathVersion === InquiryPathVersions.V1) ||
      (stores.inquiry.step < 5 && stores.inquiry.pathVersion === InquiryPathVersions.V2)
    ) {
      stores.inquiry.step += 1
      scrollToTop()
    }
  }

  finalize () {
    const registration = {
      firstName: stores.inquiry.firstName,
      lastName: stores.inquiry.lastName,
      phone: stores.inquiry.phone,
      email: stores.inquiry.email,
      address: stores.inquiry.invoicing,
      gardenSurface: stores.inquiry.gardenSurface
    }
    stores.authentication.registration = {
      ...stores.authentication.registration,
      ...registration
    }
    stores.authentication.email = stores.inquiry.email
    this.props.history.push(PagesPaths.INQUIRY_SUBMIT.path)
  }

  async updateSelectedPostalCode (postalCode) {
    if (postalCode) {
      // When coming from pro_apport link, city might be null - search by postal code only
      const city = stores.search.search.city
      if (city) {
        await stores.search.setQuery({ code1: postalCode, code2: city })
      } else {
        await stores.search.setQuery({ code1: postalCode })
      }
    } else if (stores.search.search.city) {
      await stores.search.setQuery({ code1: stores.search.search.city })
    }
  }

  pathV1 (step) {
    return <div className='layout__container demande --with-padding-bottom'>
      <Stepper>
        <Step current={step} step={0} label='common:visits:step_needs' />
        <Step current={step} step={1} label='common:visits:step_gardeners' />
        <Step current={step} step={2} label='common:visits:step_disponibilities' />
        <Step current={step} step={3} label='common:visits:step_informations' />
      </Stepper>
      {step === 0 ? <NeedsStepV1 next={() => this.next()} /> : ''}
      {step === 1 ? <GardenersStep previous={() => this.previous()} next={() => this.next()}
        onPostalCodeChange={(code) => this.updateSelectedPostalCode(code)} /> : ''}
      {step === 2 ? <DisponibilitiesStepV1 previous={() => this.previous()} next={() => this.next()} /> : ''}
      {step === 3 ? <InformationsStep previous={() => this.previous()} next={() => this.finalize()} /> : ''}
    </div>
  }

  pathV2 (step) {
    return <div className='layout__container demande --with-padding-bottom'>
      <Stepper>
        <Step current={step} step={0} label='common:visits:path_v2:step_needs' />
        <Step current={step} step={1} label='common:visits:path_v2:step_inquiry_type' />
        <Step current={step} step={2} label='common:visits:path_v2:step_gardeners' />
        <Step current={step} step={3} label='common:visits:path_v2:step_disponibilities' />
        <Step current={step} step={4} label='common:visits:path_v2:step_address' />
        <Step current={step} step={5} label={
          stores.authentication.isAuthententicated()
            ? 'common:visits:path_v2:step_complete_informations'
            : 'common:visits:path_v2:step_create_account'
        } />
      </Stepper>
      {step === 0 ? <NeedsStepV2 next={() => this.next()} /> : ''}
      {step === 1 ? <InquiryTypeV2 next={() => this.next()} /> : ''}
      {step === 2
        ? <GardenersStep
          previous={() => this.previous()}
          next={() => this.next()}
          onPostalCodeChange={(code) => this.updateSelectedPostalCode(code)} />
        : ''}
      {step === 3 ? <DisponibilitiesStepV2 previous={() => this.previous()} next={() => this.next()} /> : ''}
      {step === 4 ? <AddressStepV2 previous={() => this.previous()} next={() => this.next()} /> : ''}
      {step === 5 ? <InformationsStep previous={() => this.previous()} next={() => this.finalize()} /> : ''}
    </div>
  }

  render () {
    const { step, pathVersion } = stores.inquiry

    if (stores.search.loading) {
      return (<Loader />)
    }

    if (!stores.search.gardeners.length) {
      return (<NoGardeners postalCode={stores.search.search.postalCode} referralCode={stores.search.search.sponsor}
        onPostalCodeChange={(code) => this.updateSelectedPostalCode(code)} />)
    }

    return (
      <div>
        <SubHero breadcrumb={this.breadcrumbs} />
        {
          pathVersion === InquiryPathVersions.V1
            ? this.pathV1(step)
            : this.pathV2(step)
        }
      </div>
    )
  }
}

InquiryCreationPageComponent.propTypes = {
  t: func,
  history: shape({
    push: func
  })
}

export const InquiryCreationPage = translate()(view(InquiryCreationPageComponent))



// WEBPACK FOOTER //
// ./src/pages/demande/InquiryCreationPage.js